import { LobbyScene } from "../LobbyScene";
import { GameConstants } from "../../../GameConstants";
import { UpgradesLayer } from "./UpgradesLayer";
import { GameManager } from "../../../GameManager";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";

import * as Anuto from "../../../../engine/src";

export class UpgradeContainer extends Phaser.GameObjects.Container {

    private key: string;
    private i: number;
    private upgradesLayer: UpgradesLayer;
    private turretLevel: Phaser.GameObjects.Text;
    private turretImg: Phaser.GameObjects.Image;
    private priceText: Phaser.GameObjects.Text;
    private buyBtn: Phaser.GameObjects.Image;
    private exclamationMark: Phaser.GameObjects.Image
    private turretName: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene, x: number, y: number, i: number, upgradesLayer: UpgradesLayer) {

        super(scene);
        
        this.x = x;
        this.y = y;

        this.i = i;

        this.upgradesLayer = upgradesLayer;

        const bck = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tower_file");
        this.add(bck);

        const turretKeys = Object.keys(GameVars.turretsData);

        this.key = turretKeys[this.i];

        this.turretName = new Phaser.GameObjects.Text(this.scene, 0, -52, GameVars.turretsData[this.key].name.toUpperCase(), {fontFamily: "Lithos", fontSize: "15px", color: "#563744", align: "center"});
        this.turretName.setWordWrapWidth(100);
        this.turretName.setLineSpacing(-4);
        this.turretName.setOrigin(.5);
        this.add(this.turretName);

        const upgrade = GameVars.gameData.upgradesUnlocked[this.key];
        let turretImgName: string;

        switch(upgrade) {

            case 0:
                turretImgName = "tower_image_" + (this.i + 1) + "_1";
                break;
            case 1:
                turretImgName = "tower_image_" + (this.i + 1) + "_2";
                break;
            case 2:
                turretImgName = "tower_image_" + (this.i + 1) + "_3";
                break;
            case 3: 
                turretImgName = "tower_image_" + (this.i + 1) + "_3";
                break;
            default:
        }

        this.turretImg = new Phaser.GameObjects.Image(this.scene, 0, -5, "texture_atlas_2", turretImgName);
        this.turretImg.setScale(.85);
        this.add(this.turretImg);

        const stars = GameManager.getTotalStars();
        
        if (stars < GameVars.turretsData[this.key].stars || (GameVars.levelCompleted && GameVars.levelCompleted.totalPrevStars < GameVars.turretsData[this.key].stars && GameVars.turretsData[this.key].stars <= stars)) {
            
            this.turretName.alpha = .45;
            this.turretImg.alpha = .45;

            const numStars = new Phaser.GameObjects.Text(this.scene, 3, 50,  GameVars.turretsData[this.key].stars.toString(), {fontFamily: "Lithos", fontSize: "22px", color: "#563744", align: "center"});
            numStars.setOrigin(1, .5);
            this.add(numStars);

            const imgStar = new Phaser.GameObjects.Image(this.scene, 3, 48, "texture_atlas_1", "star");
            imgStar.setOrigin(0, .5);
            imgStar.setScale(.8);
            this.add(imgStar);

            if (GameVars.levelCompleted && GameVars.levelCompleted.totalPrevStars < GameVars.turretsData[this.key].stars && GameVars.turretsData[this.key].stars <= stars) {
               
                this.scene.time.addEvent({ delay: 2000, callback: () => {

                    numStars.visible = false;
                    imgStar.visible = false;

                    this.createButton(); 

                    this.turretImg.setScale(.5);
                    this.turretImg.alpha = 0;

                    const flare = new Phaser.GameObjects.Image(this.scene, 0, -20, "texture_atlas_1", "flare_orange");
                    flare.alpha = 0;
                    flare.setScale(0);
                    this.add(flare);

                    this.scene.tweens.add({
                        targets: this.turretImg,
                        alpha: 1,
                        scaleX: .85,
                        scaleY: .85,
                        ease: Phaser.Math.Easing.Back.Out,
                        duration: 500,
                        onComplete: () => {
                            if (!GameVars.gameData.initialTutorial && GameVars.gameData.buyTutorial) {
                                LobbyScene.currentInstance.showTutorial();
                            }
                        },
                        onCompleteScope: this
                    });

                    this.scene.tweens.add({
                        targets: flare,
                        alpha: 1,
                        scaleX: 3,
                        scaleY: 3,
                        ease: Phaser.Math.Easing.Linear,
                        duration: 200,
                        onComplete: () => {
        
                            this.scene.tweens.add({
                                targets: flare,
                                alpha: 0,
                                scaleX: 5,
                                scaleY: 5,
                                ease: Phaser.Math.Easing.Linear,
                                duration: 200,
                                onComplete: () => {
                                    flare.destroy();
                                },
                                onCompleteScope: this
                            });
                        },
                        onCompleteScope: this
                    });
                }, callbackScope: this});
            }
            
            this.exclamationMark = null;
        } else {
            this.createButton(); 
        }
    }

    public update(): void {

        if (this.exclamationMark) {

            if (GameVars.gameData.coins >= GameVars.turretsData[this.key].buy[GameVars.gameData.upgradesUnlocked[this.key]]) {
                this.exclamationMark.visible = true;
            } else {
                this.exclamationMark.visible = false;
            }
        }
    }

    public createButton(): void {

        this.turretLevel = new Phaser.GameObjects.Text(this.scene, 42, 18,  "", {fontFamily: "Lithos", fontSize: "32px", color: "#c65c2e", align: "center"});
        this.turretLevel.setOrigin(.5);
        this.add(this.turretLevel);

        this.turretImg.setInteractive();
        this.turretImg.on("pointerover", () => {
            LobbyScene.currentInstance.showTurretInfo(this.key, this.i, this.x, this.y);
        }, this);
        this.turretImg.on("pointerout", () => {
            LobbyScene.currentInstance.hideTurretInfo();
        }, this);
        
        this.buyBtn = new Phaser.GameObjects.Image(this.scene, 0, 55, "texture_atlas_1", "btn_buy");
        this.buyBtn.setInteractive();
        this.buyBtn.on("pointerdown", this.onClickBuy, this);
        this.buyBtn.on("pointerover", () => {
            this.buyBtn.setScale(1.05); 
            this.priceText.setScale(1.05); 
        }, this);
        this.buyBtn.on("pointerout", () => {
            this.buyBtn.setScale(1); 
            this.priceText.setScale(1); 
        }, this);
        this.add(this.buyBtn);

        this.priceText = new Phaser.GameObjects.Text(this.scene, 0, 53,  "", {fontFamily: "Dalek", fontSize: "20px", color: "#7E4D19", align: "center"});
        this.priceText.setOrigin(.5);
        this.add(this.priceText);

        // en la primera torre no podemos la exclamacion
        if(this.key === Anuto.GameConstants.TURRET_MORTAR && GameVars.gameData.upgradesUnlocked[this.key] === 0 ) {
            this.exclamationMark = null;
        } else {

            this.exclamationMark = new Phaser.GameObjects.Image(this.scene, 46, 40, "texture_atlas_1", "alert");
            this.add(this.exclamationMark);

            this.scene.tweens.add({
                targets: this.exclamationMark,
                scaleX: 1.3,
                scaleY: 1.3,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 225,
                yoyo: true,
                repeat: -1
            });
        }

        this.updateInfo();
    }

    public onClickBuy(): void {

        if (GameVars.gameData.buyTutorial) {
            return;
        }

        if (GameVars.gameData.coins < GameVars.turretsData[this.key].buy[GameVars.gameData.upgradesUnlocked[this.key]]) {
            return;
        }

        if (GameVars.gameData.upgradesUnlocked[this.key] === GameConstants.MAX_UPGRADES) {
            return;
        }

        GameManager.buyUpgradeTurret(this.key);
        this.upgradesLayer.updateInfo();

        const flare = new Phaser.GameObjects.Image(this.scene, 0, -20, "texture_atlas_1", "flare_orange");
        flare.alpha = 0;
        flare.setScale(0);
        this.add(flare);

        this.scene.tweens.add({
            targets: flare,
            alpha: 1,
            scaleX: 3,
            scaleY: 3,
            ease: Phaser.Math.Easing.Linear,
            duration: 200,
            onComplete: () => {

                this.scene.tweens.add({
                    targets: flare,
                    alpha: 0,
                    scaleX: 5,
                    scaleY: 5,
                    ease: Phaser.Math.Easing.Linear,
                    duration: 200,
                    onComplete: () => {
                        flare.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        AudioManager.playSound("buy_tower_upgrade");
    }

    public updateInfo(): void {

        const stars = GameManager.getTotalStars();
        
        if (stars >= GameVars.turretsData[this.key].stars) {

            const upgrade = GameVars.gameData.upgradesUnlocked[this.key];

            let turretImgName: string;
            let level: number;
    
            switch(upgrade) {
    
                case 0:
                    turretImgName = "tower_image_" + (this.i + 1) + "_1";
                    level = upgrade;
                    break;
                case 1:
                    turretImgName = "tower_image_" + (this.i + 1) + "_2";
                    level = upgrade + 1;
                    break;
                case 2:
                    turretImgName = "tower_image_" + (this.i + 1) + "_3";
                    level = upgrade + 1;
                    break;
                case 3: 
                    turretImgName = "tower_image_" + (this.i + 1) + "_3";
                    level = upgrade;
                    break;
                default:
            }

            this.turretImg.setFrame(turretImgName);
            this.turretLevel.setText(level.toString());

            if (GameVars.gameData.upgradesUnlocked[this.key] === 0) {
                this.turretLevel.visible = false;
                this.turretImg.alpha = .5;
            } else {
                this.turretLevel.visible = true;
                this.turretImg.alpha = 1;
            }

            if (GameVars.gameData.upgradesUnlocked[this.key] === GameConstants.MAX_UPGRADES) {
                this.priceText.setText("MAX");
                this.priceText.setColor("#cd2b2b");

                this.buyBtn.input.enabled = false;
                this.buyBtn.alpha = .5;
                this.priceText.alpha = .5;
            } else {
                this.priceText.setText(GameVars.turretsData[this.key].buy[GameVars.gameData.upgradesUnlocked[this.key]]);

                if (GameVars.gameData.coins < GameVars.turretsData[this.key].buy[GameVars.gameData.upgradesUnlocked[this.key]]) {
                    this.buyBtn.input.enabled = false;
                    this.buyBtn.alpha = .5;
                    this.priceText.alpha = .5;
                    this.priceText.setColor("#cd2b2b");
                } else {
                    this.buyBtn.input.enabled = true;
                    this.buyBtn.alpha = 1;
                    this.priceText.alpha = 1;
                    this.priceText.setColor("#7E4D19");
                }
            }
        }
    }
}
